var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "File Info") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Associate",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cv-associate-topic-detail-copy-3",
    transform: "translate(-1220.000000, -269.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(421.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Template---Table-Copy",
    transform: "translate(0.000000, 173.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8-Icon-color",
    transform: "translate(799.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C18.624447,0.00716484761 23.9928352,5.37555305 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 Z M11.9989184,2.00000006 C6.47656798,2.00058455 2,6.47751304 2,12.0000001 C2,17.5228475 6.4771525,22.0000001 12,22.0000001 C17.5228475,22.0000001 22,17.5228475 22,12.0021632 C21.9940296,6.48095644 17.5199884,2.00655518 11.9989184,2.00000006 Z M11.5,9.5 C12.6045695,9.5 13.5,10.3954305 13.5,11.5 L13.5,16.25 C13.5,16.3880712 13.6119288,16.5 13.75,16.5 L14.5,16.5 C15.0522847,16.5 15.5,16.9477153 15.5,17.5 C15.5,18.0522847 15.0522847,18.5 14.5,18.5 L10.5,18.5 C9.94771525,18.5 9.5,18.0522847 9.5,17.5 C9.5,16.9477153 9.94771525,16.5 10.5,16.5 L11.25,16.5 C11.3880712,16.5 11.5,16.3880712 11.5,16.25 L11.5,11.75 C11.5,11.6119288 11.3880712,11.5 11.25,11.5 L10.5,11.5 C9.94771525,11.5 9.5,11.0522847 9.5,10.5 C9.5,9.94771525 9.94771525,9.5 10.5,9.5 L11.5,9.5 Z M11.7308049,5.5503679 C12.4211608,5.5503679 12.9808049,6.11001196 12.9808049,6.8003679 C12.9808049,7.49072384 12.4211608,8.0503679 11.7308049,8.0503679 C11.0404489,8.0503679 10.4808049,7.49072384 10.4808049,6.8003679 C10.4808049,6.11001196 11.0404489,5.5503679 11.7308049,5.5503679 Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.2da92cc966f34af6feee92c1a05add25.svg";
export { ForwardRef as ReactComponent };